import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const finalizeTurn = async ({ id, params, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.ADP.TURNOS.FINALIZAR_TURNO}${id}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default finalizeTurn;